import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface InvoiceDto {
    id: number;
    user: string;
    price: number;
    issueDate: string;
    dueDate: string;
    status: string;
}

export interface InvoicesResponse {
    items: InvoiceDto[];
    total: number;
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

    private invoices: InvoiceDto[] = [
        { id: 1, user: 'John Doe', price: 150, issueDate: '2025-01-01', dueDate: '2025-01-15', status: 'Sent' },
        { id: 2, user: 'Jane Smith', price: 250, issueDate: '2025-01-05', dueDate: '2025-01-20', status: 'Failed' },
        { id: 3, user: 'Alice Johnson', price: 400, issueDate: '2025-02-01', dueDate: '2025-02-15', status: 'Sent' },
        { id: 4, user: 'Bob Williams', price: 300, issueDate: '2025-02-10', dueDate: '2025-02-25', status: 'Sent' },
        { id: 5, user: 'Charlie Brown', price: 120, issueDate: '2025-03-01', dueDate: '2025-03-15', status: 'Failed' },
        { id: 6, user: 'Daniel Green', price: 180, issueDate: '2025-03-05', dueDate: '2025-03-20', status: 'Failed' },
        { id: 7, user: 'Emma White', price: 500, issueDate: '2025-03-10', dueDate: '2025-03-25', status: 'Sent' },
        { id: 8, user: 'Frank Black', price: 220, issueDate: '2025-03-15', dueDate: '2025-03-30', status: 'Failed' },
        { id: 9, user: 'Grace Blue', price: 350, issueDate: '2025-04-01', dueDate: '2025-04-15', status: 'Sent' },
        { id: 10, user: 'Henry Red', price: 400, issueDate: '2025-04-05', dueDate: '2025-04-20', status: 'Failed' },
        { id: 11, user: 'Ivy Purple', price: 275, issueDate: '2025-04-10', dueDate: '2025-04-25', status: 'Failed' },
        { id: 12, user: 'Jack Orange', price: 190, issueDate: '2025-04-15', dueDate: '2025-04-30', status: 'Sent' },
        { id: 13, user: 'Karen Yellow', price: 320, issueDate: '2025-05-01', dueDate: '2025-05-15', status: 'Failed' },
        { id: 14, user: 'Leo Cyan', price: 410, issueDate: '2025-05-05', dueDate: '2025-05-20', status: 'Sent' },
        { id: 15, user: 'Mia Pink', price: 150, issueDate: '2025-05-10', dueDate: '2025-05-25', status: 'Sent' }
    ];

    constructor() {}

    getInvoices(params: { page?: number; pageSize?: number; searchText?: string } = {}): Observable<InvoicesResponse> {
        const page = params.page ?? 1;
        const pageSize = params.pageSize ?? 10;
        const searchText = params.searchText?.toLowerCase() ?? '';

        let filtered = this.invoices;

        if (searchText) {
            filtered = filtered.filter(inv =>
                inv.user.toLowerCase().includes(searchText) ||
                inv.status.toLowerCase().includes(searchText) ||
                inv.id.toString() === searchText
            );
        }

        const start = (page - 1) * pageSize;
        const end = start + pageSize;

        const paged = filtered.slice(start, end);

        return of({ items: paged, total: filtered.length });
    }

    getInvoiceById(id: number): Observable<InvoiceDto | undefined> {
        const invoice = this.invoices.find(inv => inv.id === id);
        return of(invoice);
    }
}